import { BRAND, IMG } from "../lib/brand";
import { Instagram, Facebook } from "lucide-react";
import { useContent } from "../context/ContentContext";

export default function About() {
    const { content } = useContent();
    const a = content.about;
    const img1 = a.image_1 || IMG.community[0];
    const img2 = a.image_2 || IMG.community[1];
    const img3 = a.image_3 || IMG.engine;

    return (
        <section id="about" data-testid="about-section" className="relative py-24 md:py-40 bg-meraki-bg">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                <div className="lg:col-span-7">
                    <div className="flex items-center gap-3 mb-8">
                        <span className="font-mono text-meraki-gold text-sm">01</span>
                        <div className="w-8 h-px bg-meraki-gold" />
                        <span className="text-[10px] uppercase tracking-[0.4em] text-meraki-gold">{a.eyebrow}</span>
                    </div>

                    <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.95] text-meraki-text">
                        {a.heading_line1} <span className="text-meraki-gold italic font-heading font-light">{a.heading_emph}</span>.<br />
                        {a.heading_line2}
                    </h2>

                    <div className="mt-10 space-y-6 max-w-2xl">
                        <p className="text-meraki-text/85 text-lg leading-relaxed whitespace-pre-line">{a.meraki_definition}</p>
                        <p className="text-meraki-muted leading-relaxed whitespace-pre-line">{a.body}</p>
                    </div>

                    <div className="mt-12 flex flex-wrap gap-4">
                        <a href={BRAND.instagram} target="_blank" rel="noreferrer" data-testid="about-instagram-link" className="group flex items-center gap-3 px-5 py-3 border border-meraki-gold/30 hover:border-meraki-gold transition-colors">
                            <Instagram className="w-4 h-4 text-meraki-gold" />
                            <span className="text-xs uppercase tracking-[0.2em] text-meraki-text group-hover:text-meraki-gold transition-colors">{a.instagram_label}</span>
                        </a>
                        <a href={BRAND.facebook} target="_blank" rel="noreferrer" data-testid="about-facebook-link" className="group flex items-center gap-3 px-5 py-3 border border-meraki-gold/30 hover:border-meraki-gold transition-colors">
                            <Facebook className="w-4 h-4 text-meraki-gold" />
                            <span className="text-xs uppercase tracking-[0.2em] text-meraki-text group-hover:text-meraki-gold transition-colors">{a.facebook_label}</span>
                        </a>
                    </div>

                    <div className="mt-8 flex flex-wrap gap-2">
                        {BRAND.hashtags.map((tag) => (
                            <span key={tag} className="text-xs text-meraki-gold/80 font-mono">{tag}</span>
                        ))}
                    </div>
                </div>

                <div className="lg:col-span-5 relative h-[480px] md:h-[600px]">
                    <div className="absolute top-0 right-0 w-[75%] h-[60%] overflow-hidden border border-meraki-gold/20">
                        <img src={img1} alt="Riders" className="w-full h-full object-cover gallery-img" />
                    </div>
                    <div className="absolute bottom-0 left-0 w-[65%] h-[55%] overflow-hidden border border-meraki-gold/30 shadow-2xl shadow-black">
                        <img src={img2} alt="Group ride" className="w-full h-full object-cover" />
                    </div>
                    <div className="absolute bottom-12 right-4 w-32 h-32 border-2 border-meraki-gold rotate-6 overflow-hidden hidden md:block">
                        <img src={img3} alt="Accent" className="w-full h-full object-cover" />
                    </div>
                </div>
            </div>
        </section>
    );
}
